module.exports = __webpack_public_path__ + "img/uso.b2c2651b.jpg";